import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface BookingType {
  id: number;
  name: string;
}

export const useBookingTypes = () => {
  const [bookingTypes, setBookingTypes] = useState<BookingType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBookingTypes = async () => {
      try {
        const { data, error } = await supabase
          .from('bookings_type')
          .select('id, name')
          .order('name');

        if (error) throw error;
        setBookingTypes(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch booking types');
      } finally {
        setLoading(false);
      }
    };

    fetchBookingTypes();
  }, []);

  return { bookingTypes, loading, error };
}; 